import { sendRequest } from "../sendRequest";

export const checkConversation = ({ userId }) => {
  return sendRequest(
    "get",
    `/influencer/chat/conversation-exist?userId=${userId}`
  ).then((res) => res.data);
};
